export default __webpack_public_path__ + "d9884da53fab6c97b3e35a19159fb8d1.svg";